import { required } from 'vuelidate/lib/validators';

export default requiredUnless => function (value, parentVm) {
  const compareTo = typeof requiredUnless === 'function'
    ? requiredUnless.call(this, parentVm)
    : parentVm[requiredUnless];
  return compareTo || required(value);
};



// WEBPACK FOOTER //
// ./src/utils/validators/RequiredUnless.js